import { remove as removeDiacritics } from 'diacritics'

export default function matchWords (needle, haystack) {
    const normalizedNeedle = removeDiacritics(String(needle).toLowerCase())
    const normalizedHaystack = removeDiacritics(String(haystack).toLowerCase())

    return normalizedNeedle.split(/\s+/).every((word) => normalizedHaystack.includes(word))
}
